import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const profitWell = defineConnector({
  identifier: "profitWell",
  name: "ProfitWell",
  tagLine: "Subscription analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.profitwell\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [ProfitWell](https://www.profitwell.com/), go to **Account Settings → Integrations → API** to find your access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.profitwell.com/v2/company/settings/",
  },
});
